import { render, staticRenderFns } from "./TenderDetailsDialog.vue?vue&type=template&id=2a760986"
import script from "./TenderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TenderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./TenderDetailsDialog.vue?vue&type=style&index=0&id=2a760986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports